import { organizationSettingsConstants as osc } from 'srcReact/OrganizationSettingsPage'
import { organizationService, workplaceService } from 'srcReact/services'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { openInNewTab } from 'srcReact/helpers/utils'
import { commonActions } from 'srcReact/components'

const PAGINATION_QUANTITY = appConstantSettings.WORKPLACE_PAGINATION_QUANTITY

export const organizationSettingsActions = {
  getOrganizationInfo,
  editOrganizationInfo,
  getOrganizationWorkplaceList,
  getLeadershipTeam,
  getOrganizationMembers,
  getOrganizationSubscription,
  getPaymentInformationUrl,
  getInvoices,
  downloadInvoice,
  deleteWorkplace,
  updateMemberRole,
  removeMember,
  reinstateAccount,
  deleteAccount,
  getOrgFiles,
  addOrgFile,
  updateOrgFile,
  deleteOrgFile,
  clearFlagsForOrgDocs,
  updateOrgRole
}

function getOrganizationInfo(organization_id) {
  return (dispatch) => {
    dispatch(request({ organization_id }))
    organizationService.getOrganizationInfo(organization_id).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: osc.GET_ORGANIZATION_INFO_REQUEST, data }
  }
  function success(data) {
    return { type: osc.GET_ORGANIZATION_INFO_SUCCESS, data }
  }
  function failure(error) {
    return { type: osc.GET_ORGANIZATION_INFO_FAILURE, error }
  }
}

function editOrganizationInfo({ organization_id, name, color, accronym, google_translation_key, picture_id }) {
  return (dispatch) => {
    dispatch(request({ organization_id, name, color, accronym, picture_id }))
    organizationService
      .editOrganizationInfo(organization_id, name, color, accronym, google_translation_key, picture_id)
      .then(
        (response) => {
          dispatch(success(response))
          dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(data) {
    return { type: osc.EDIT_ORGANIZATION_INFO_REQUEST, data }
  }
  function success(data) {
    return { type: osc.EDIT_ORGANIZATION_INFO_SUCCESS, data }
  }
  function failure(error) {
    return { type: osc.EDIT_ORGANIZATION_INFO_FAILURE, error }
  }
}

function getOrganizationWorkplaceList(organization_id) {
  return (dispatch) => {
    dispatch(request({ organization_id }))
    organizationService.getOrganizationWorkplaceList(organization_id).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: osc.GET_ORGANIZATION_WORKPLACE_LIST_REQUEST, data }
  }
  function success(data) {
    return { type: osc.GET_ORGANIZATION_WORKPLACE_LIST_SUCCESS, data }
  }
  function failure(error) {
    return { type: osc.GET_ORGANIZATION_WORKPLACE_LIST_FAILURE, error }
  }
}

function getLeadershipTeam(organization_id, orderby = 'lastname') {
  return (dispatch) => {
    dispatch(request({ organization_id, orderby }))
    organizationService.getLeadershipTeam(organization_id, orderby).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: osc.GET_LEADERSHIP_TEAM_REQUEST, data }
  }
  function success(data) {
    return { type: osc.GET_LEADERSHIP_TEAM_SUCCESS, data }
  }
  function failure(error) {
    return { type: osc.GET_LEADERSHIP_TEAM_FAILURE, error }
  }
}

function getOrganizationMembers(
  organization_id,
  search = '',
  orderby = 'lastname',
  deactivated = 0,
  requestToDelete = 0,
  offset = 0,
  quantity = PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(request({ organization_id, search, orderby, offset, quantity }))
    organizationService
      .getOrganizationMembers(organization_id, search, orderby, deactivated, requestToDelete, offset, quantity)
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(data) {
    return { type: osc.GET_ORGANIZATION_MEMBERS_REQUEST, data }
  }
  function success(data) {
    return { type: osc.GET_ORGANIZATION_MEMBERS_SUCCESS, data }
  }
  function failure(error) {
    return { type: osc.GET_ORGANIZATION_MEMBERS_FAILURE, error }
  }
}

function getOrganizationSubscription(organization_id, from_chargebee = 0) {
  return (dispatch) => {
    dispatch(request({ organization_id, from_chargebee }))
    organizationService.getOrganizationSubscription(organization_id, from_chargebee).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: osc.GET_ORGANIZATION_SUBSCRIPTION_REQUEST, data }
  }
  function success(data) {
    return { type: osc.GET_ORGANIZATION_SUBSCRIPTION_SUCCESS, data }
  }
  function failure(error) {
    return { type: osc.GET_ORGANIZATION_SUBSCRIPTION_FAILURE, error }
  }
}

function getPaymentInformationUrl(organization_id) {
  return (dispatch) => {
    dispatch(request({ organization_id }))
    organizationService.getPaymentInformationUrl(organization_id).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: osc.GET_PAYMENT_INFORMATION_URL_REQUEST, data }
  }
  function success(data) {
    return { type: osc.GET_PAYMENT_INFORMATION_URL_SUCCESS, data }
  }
  function failure(error) {
    return { type: osc.GET_PAYMENT_INFORMATION_URL_FAILURE, error }
  }
}

function getInvoices(organization_id, start_date, end_date) {
  return (dispatch) => {
    dispatch(request({ organization_id, start_date, end_date }))
    organizationService.getInvoices(organization_id, start_date, end_date).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: osc.GET_INVOICES_REQUEST, data }
  }
  function success(data) {
    return { type: osc.GET_INVOICES_SUCCESS, data }
  }
  function failure(error) {
    return { type: osc.GET_INVOICES_FAILURE, error }
  }
}

function downloadInvoice(organization_id, invoice_id) {
  return (dispatch) => {
    dispatch(request({ organization_id, invoice_id }))
    organizationService.downloadInvoice(organization_id, invoice_id).then(
      (response) => {
        const { download } = response
        openInNewTab(download.download_url)
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: osc.GET_DOWNLOAD_INVOICE_REQUEST, data }
  }
  function success(data) {
    return { type: osc.GET_DOWNLOAD_INVOICES_SUCCESS, data }
  }
  function failure(error) {
    return { type: osc.GET_DOWNLOAD_INVOICES_FAILURE, error }
  }
}

function deleteWorkplace(workplace_id) {
  return (dispatch) => {
    dispatch(request({ workplace_id }))
    workplaceService.remove(workplace_id).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: osc.DELETE_WORKPLACE_REQUEST, data }
  }
  function success(data) {
    return { type: osc.DELETE_WORKPLACE_SUCCESS, data }
  }
  function failure(error) {
    return { type: osc.DELETE_WORKPLACE_FAILURE, error }
  }
}

function updateMemberRole(workplace_id, member, fromPage) {
  return (dispatch) => {
    dispatch(request({ workplace_id, member }))
    workplaceService.updateRole(workplace_id, member.resourceKey, member.roles, member.action).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: osc.UPDATE_MEMBER_ROLE_REQUEST, data }
  }
  function success(data) {
    return { type: osc.UPDATE_MEMBER_ROLE_SUCCESS, data, fromPage }
  }
  function failure(error) {
    return { type: osc.UPDATE_MEMBER_ROLE_FAILURE, error }
  }
}

function removeMember(workplace_id, user_id, dashboard = 0) {
  return (dispatch) => {
    dispatch(request({ workplace_id, user_id }))
    workplaceService.removeUserFromWorkplace(workplace_id, user_id, dashboard).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: osc.REMOVE_MEMBER_REQUEST, data }
  }
  function success(data) {
    return { type: osc.REMOVE_MEMBER_SUCCESS, data, user_id }
  }
  function failure(error) {
    return { type: osc.REMOVE_MEMBER_FAILURE, error }
  }
}

function reinstateAccount(orgId, userId) {
  return (dispatch) => {
    dispatch(request({ orgId, userId }))
    organizationService.reinstateUser(orgId, userId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: osc.REINSTATE_ACCOUNT_REQUEST, response }
  }
  function success(response) {
    return { type: osc.REINSTATE_ACCOUNT_SUCCESS, response }
  }
  function failure(error) {
    return { type: osc.REINSTATE_ACCOUNT_FAILURE, error }
  }
}

function deleteAccount(orgId, userId, groupTransferData) {
  return (dispatch) => {
    dispatch(request({ orgId, userId }))
    organizationService.deleteAccount(orgId, userId, groupTransferData).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: osc.DELETE_ACCOUNT_REQUEST, response }
  }
  function success(response) {
    return { type: osc.DELETE_ACCOUNT_SUCCESS, response }
  }
  function failure(error) {
    return { type: osc.DELETE_ACCOUNT_FAILURE, error }
  }
}

function getOrgFiles(orgId, offset, quantity = PAGINATION_QUANTITY) {
  return (dispatch) => {
    dispatch(request({ orgId }))
    organizationService.getOrgFiles(orgId, offset, quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: osc.GET_ORG_FILES_REQUEST, response }
  }
  function success(response) {
    return { type: osc.GET_ORG_FILES_SUCCESS, response }
  }
  function failure(error) {
    return { type: osc.GET_ORG_FILES_FAILURE, error }
  }
}

function addOrgFile(orgId, fileId, fileUrl) {
  return (dispatch) => {
    dispatch(request({ orgId, fileId, fileUrl }))
    organizationService.addOrgFile(orgId, fileId, fileUrl).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: osc.ADD_ORG_FILE_REQUEST, response }
  }
  function success(response) {
    return { type: osc.ADD_ORG_FILE_SUCCESS, response }
  }
  function failure(error) {
    return { type: osc.ADD_ORG_FILE_FAILURE, error }
  }
}

function updateOrgFile(orgId, id, newFileId, newFileUrl) {
  return (dispatch) => {
    dispatch(request({ orgId, id, newFileId, newFileUrl }))
    organizationService.updateOrgFile(orgId, id, newFileId, newFileUrl).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: osc.UPDATE_ORG_FILE_REQUEST, response }
  }
  function success(response) {
    return { type: osc.UPDATE_ORG_FILE_SUCCESS, response }
  }
  function failure(error) {
    return { type: osc.UPDATE_ORG_FILE_FAILURE, error }
  }
}

function deleteOrgFile(orgId, id) {
  return (dispatch) => {
    dispatch(request({ orgId, id }))
    organizationService.deleteOrgFile(orgId, id).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: osc.DELETE_ORG_FILE_REQUEST, response }
  }
  function success(response) {
    return { type: osc.DELETE_ORG_FILE_SUCCESS, response }
  }
  function failure(error) {
    return { type: osc.DELETE_ORG_FILE_FAILURE, error }
  }
}

function updateOrgRole(orgId, userId, role, action, listType) {
  return (dispatch) => {
    dispatch(request({ orgId, userId, role, action }))

    organizationService.updateOrgRole(orgId, userId, role, action).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: osc.UPDATE_ORG_ROLE_REQUEST, response }
  }
  function success(response) {
    return { type: osc.UPDATE_ORG_ROLE_SUCCESS, response, userId, listType }
  }
  function failure(error) {
    return { type: osc.UPDATE_ORG_ROLE_FAILURE, error }
  }
}

function clearFlagsForOrgDocs() {
  return { type: osc.CLEAR_FLAGS_ORG_DOCS }
}
